<template>
  <div class="section1">
    <el-form inline>
      <el-form-item>
        <el-select v-model="searchForm.projectId" placeholder="项目名称">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="searchForm.yearMonth" :clearable="false" value-format="yyyy-MM" type="month"
          placeholder="请选择月份"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="title">
      <span class="name">项目信息</span>
    </div>
    <div class="items">
      <div class="item">
        <span class="label">养护面积（㎡）</span>
        <div class="value">
          <span>{{ details.maintainAcreage }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">养护金额（元）</span>
        <div class="value">
          <span>¥</span>
          <span>{{ details.maintainAmount || '0' }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">养护等级</span>
        <div class="value">
          <span>{{ details.maintainLevelName || '--' }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">开始时间</span>
        <div class="value">
          <span>{{ details.maintStartTime || '--' }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">结束时间</span>
        <div class="value">
          <span>{{ details.maintEndTime || '--' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from '@/utils/util'

export default {
  name: 'Section1',
  data() {
    return {
      searchForm: {
        projectId: '',
        yearMonth: ''
      },
      details: {
        maintainAcreage: '', // 养护面积
        maintainAmount: '', // 养护金额
        maintainLevelName: '', // 养护等级
        maintStartTime: '', // 开始时间
        maintEndTime: '' // 结束时间
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
  },
  created() {
    // do something
    this.searchForm.yearMonth = this.$dayjs().format('YYYY-MM')
    this.searchForm.projectId = this.projectList[0].projectId
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.operate.selectProject, this.searchForm).then(res => {
        this.details = res
        this.$event.$emit('projectSearchChange', deepClone(this.searchForm))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section1 {
  padding: 20px;

  .title {
    margin-top: 22px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .items {
    display: flex;
    align-items: center;

    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0 50px;
      position: relative;

      &:nth-child(n + 2) {

        &::before {
          content: '';
          position: absolute;
          width: 1px;
          height: 81px;
          background-color: #E3E3E3;
          top: 0;
          left: -40px;
        }
      }

      .label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }

      .value {
        margin-top: 20px;

        span {
          &:first-child {
            font-size: 24px;
          }

          &:last-child {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 30px;
            color: #333333;
            line-height: 38px;
            text-align: left;
            font-style: normal;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
